import DashboardFilterPanel from './dashboardFilterPanel.container'

export default DashboardFilterPanel